type ErrorLike = {
  status?: number | 'other';
  message?: string;
};

export function extractError(e: ErrorWithStatus | unknown): ErrorWithStatus {
  return e instanceof ErrorWithStatus
    ? e
    : new ErrorWithStatus((e as ErrorLike)?.message ?? 'Internal error', (e as ErrorLike)?.status);
}

export class ErrorWithStatus extends Error {
  status: number | 'other';

  message: string;

  constructor(message = '', status: number | 'other' = 'other') {
    super(message);
    this.status = status;
    this.message = message;
  }
}
